<template>
    <v-wait for="loading services" class="layout column fill-height">
      <template slot="waiting">
        <vcl-list height='200'></vcl-list>
      </template>
      <service-card
        v-for="service in this.services"
        :key="service.id"
        :value="service"
        @move="moveService($event.service, $event.date)"
      ></service-card>
      <div class="subtitle-1" v-if="!services || services.length === 0">No services due today</div>
    </v-wait>
</template>
<script>
  import { VclList } from 'vue-content-loading';
  import Services from '@/components/Services/ServicesClient.vue';
  import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';
  import Controls from '@/components/Calendar/Day/Controls.vue';
  import { Event } from '@/plugins/bus';
  import { DateFormat } from '@/plugins/date-filter';
  import moment from 'moment';
  import ServiceCard from './ServiceCard.vue';

  export default {
    mixins: [
      GarageLocations,
      Controls,
      Services,
    ],
    data() {
      return {
        services: [],
      };
    },
    components: {
      VclList,
      ServiceCard,
    },
    methods: {
      async handleServiceCompleted() {
        this.services = await this.getServices();
      },
      async handleServiceMoved(data) {
        this.$toast.success(`Moved ${data.unit} to ${moment(data.date).format(DateFormat.DefaultDisplay)}`);
        this.services = await this.getServices();
      },
    },
    async mounted() {
      this.services = await this.getServices();
      this.$bus.$on(Event.ServiceCompleted, this.handleServiceCompleted);
      this.$bus.$on(Event.ServiceMoved, this.handleServiceMoved);
    },
    destroyed() {
      this.$bus.$off(Event.ServiceCompleted, this.handleServiceCompleted);
      this.$bus.$off(Event.ServiceMoved, this.handleServiceMoved);
    },
    watch: {
      async current(val) {
        this.services = await this.getServices();
      },
      async userGarage(val) {
        this.services = await this.getServices();
      },
    },
  };
</script>
